import React from "react";
import {
  AreaChart,
  linearGradient,
  Tooltip,
  Area,
  ResponsiveContainer,
  XAxis,
  YAxis,
  CartesianGrid,
  Scatter,
  ScatterChart,
  ZAxis,
  Legend,
  FunnelChart,
  Funnel,
  Cell,
  LabelList,
  RadialBarChart,
  RadialBar,
  Pie,
  PieChart,
  Sector,
} from "recharts";
import clsx from "clsx";
import useInterval from "@rooks/use-interval";
import { useEffect, useState, useContext } from "react";
import { ConfigContext } from "../../../contexts/ConfigContext";

import axios from "../../../api/axios";

import CustomTooltip from "../../../utils/CustomTooltip";
import { xy2ll } from "../../../utils/NDSFutility";
import { filter } from "lodash";
import useConfig from "../../../hooks/useConfig";
import useAuth from "../../../hooks/authenticate/useAuth";

var request_updateTimelineData_safe = true;

var offset = new Date().getTimezoneOffset() / 60;
if (offset < 0) {
  offset *= -1;
  offset = Math.floor(offset);
}

function getLocalHour(date) {
  if (date) {
    let hour = new Date(date).getHours();
    return hour < 10 ? `0${hour}:00` : `${hour}:00`;
  }
}
function findHourData(timeline, hour) {
  for (let i = 0; i < timeline.length; i++) {
    if (timeline[i]["hour"] === hour) {
      return timeline[i];
    }
  }
  return -1;
}

function funnelTimelineLogic(timeline, label, type) {
  let data = [];

  let dataAreato0p8 = [];
  let dataAreato1p5 = [];
  let dataAreato2 = [];

  let dataAreato4 = [];
  let dataAreaAbove4 = [];

  let dataXto0p8 = [];
  let dataXto2 = [];
  let dataXto1p5 = [];
  let dataXto4 = [];
  let dataXAbove4 = [];

  let dataYto0p8 = [];
  let dataYto1p5 = [];
  let dataYto2 = [];
  let dataYto4 = [];
  let dataYAbove4 = [];

  let dataVel0to10;
  let dataVel10to15;
  let dataVel15to20;
  let dataVel20to30;
  let dataVelAbove30;
  if (timeline) {
    if (type === 0) {
      dataYto0p8 = timeline
        .filter((val) => val["dim(Y)"] < 0.8)
        .map((val) => {
          return {
            key:
              val["dim(X)"].toFixed(4) +
              val["dim(Y)"].toFixed(4) +
              val["Velocity"].toFixed(4),
            // "dim(X)": val["dim(X)"],
            "dim(Y)": val["dim(Y)"],
            // Velocity: val["Velocity"],
          };
        });
      dataYto1p5 = timeline
        .filter((val) => val["dim(Y)"] >= 0.8 && val["dim(Y)"] < 1.5)
        .map((val) => {
          return {
            key:
              val["dim(X)"].toFixed(4) +
              val["dim(Y)"].toFixed(4) +
              val["Velocity"].toFixed(4),
            // "dim(X)": val["dim(X)"],
            "dim(Y)": val["dim(Y)"],
            // Velocity: val["Velocity"],
          };
        });
      dataYto2 = timeline
        .filter((val) => val["dim(Y)"] >= 1.5 && val["dim(Y)"] < 2)
        .map((val) => {
          return {
            key:
              val["dim(X)"].toFixed(4) +
              val["dim(Y)"].toFixed(4) +
              val["Velocity"].toFixed(4),
            // "dim(X)": val["dim(X)"],
            "dim(Y)": val["dim(Y)"],
            // Velocity: val["Velocity"],
          };
        });

      dataYto4 = timeline
        .filter((val) => val["dim(Y)"] >= 2 && val["dim(Y)"] < 4)
        .map((val) => {
          return {
            key:
              val["dim(X)"].toFixed(4) +
              val["dim(Y)"].toFixed(4) +
              val["Velocity"].toFixed(4),
            // "dim(X)": val["dim(X)"],
            "dim(Y)": val["dim(Y)"],
            // Velocity: val["Velocity"],
          };
        });
      dataYAbove4 = timeline
        .filter((val) => val["dim(Y)"] >= 4)
        .map((val) => {
          return {
            key:
              val["dim(X)"].toFixed(4) +
              val["dim(Y)"].toFixed(4) +
              val["Velocity"].toFixed(4),
            // "dim(X)": val["dim(X)"],
            "dim(Y)": val["dim(Y)"],
            // Velocity: val["Velocity"],
          };
        });

      dataVel0to10 = timeline
        .filter((val) => val["Velocity"] < 10)
        .map((val) => {
          return {
            key:
              val["dim(X)"].toFixed(4) +
              val["dim(Y)"].toFixed(4) +
              val["Velocity"].toFixed(4),
            // "dim(X)": val["dim(X)"],
            // "dim(Y)": val["dim(Y)"],
            Velocity: val["Velocity"],
          };
        });
      dataVel10to15 = timeline
        .filter((val) => val["dim(Y)"] >= 10 && val["Velocity"] < 15)
        .map((val) => {
          return {
            key:
              val["dim(X)"].toFixed(4) +
              val["dim(Y)"].toFixed(4) +
              val["Velocity"].toFixed(4),
            // "dim(X)": val["dim(X)"],
            // "dim(Y)": val["dim(Y)"],
            Velocity: val["Velocity"],
          };
        });
      dataVel15to20 = timeline
        .filter((val) => val["dim(Y)"] >= 15 && val["Velocity"] < 20)
        .map((val) => {
          return {
            key:
              val["dim(X)"].toFixed(4) +
              val["dim(Y)"].toFixed(4) +
              val["Velocity"].toFixed(4),
            // "dim(X)": val["dim(X)"],
            // "dim(Y)": val["dim(Y)"],
            Velocity: val["Velocity"],
          };
        });

      dataVel20to30 = timeline
        .filter((val) => val["dim(Y)"] >= 20 && val["Velocity"] < 30)
        .map((val) => {
          return {
            key:
              val["dim(X)"].toFixed(4) +
              val["dim(Y)"].toFixed(4) +
              val["Velocity"].toFixed(4),
            // "dim(X)": val["dim(X)"],
            // "dim(Y)": val["dim(Y)"],
            Velocity: val["Velocity"],
          };
        });
      dataVelAbove30 = timeline
        .filter((val) => val["Velocity"] >= 30)
        .map((val) => {
          return {
            key:
              val["dim(X)"].toFixed(4) +
              val["dim(Y)"].toFixed(4) +
              val["Velocity"].toFixed(4),
            // "dim(X)": val["dim(X)"],
            // "dim(Y)": val["dim(Y)"],
            Velocity: val["Velocity"],
          };
        });

      data.push({
        name: "Dimension Y 0-0.8 \n" + label,
        count: dataYto0p8.length,
        data: dataYto0p8,
        fill: "#ed2015",
      });
      data.push({
        name: "Dimension Y 0.8-1.5\n " + label,
        count: dataYto1p5.length,
        data: dataYto1p5,
        fill: "#1559ed",
      });
      data.push({
        name: "Dimension Y 1.5-2 \n" + label,
        count: dataYto2.length,
        data: dataYto2,
        fill: "#28a649",
      });
      data.push({
        name: "Dimension Y 2-4 \n" + label,
        count: dataYto4.length,
        data: dataYto4,
        fill: "#9315ed",
      });
      data.push({
        name: "Dimension Y 4 and Above \n" + label,
        count: dataYAbove4.length,
        data: dataYAbove4,
        fill: "#15c2ed",
      });

      data.push({
        name: "Velocity 0-10 \n" + label,
        count: dataVel0to10.length,
        data: dataVel0to10,
        fill: "#ff7300",
      });
      data.push({
        name: "Velocity 10-15 \n" + label,
        count: dataVel10to15.length,
        data: dataVel10to15,
        fill: "#ed5d15",
      });
      data.push({
        name: "Velocity 10-20 \n" + label,
        count: dataVel15to20.length,
        data: dataVel15to20,
        fill: "#15a5ed",
      });
      data.push({
        name: "Velocity 20-30 \n" + label,
        count: dataVel20to30.length,
        data: dataVel20to30,
        fill: "#7aed15",
      });
      data.push({
        name: "Velocity 30 and Above \n" + label,
        count: dataVelAbove30.length,
        data: dataVelAbove30,
        fill: "#00a181",
      });
      data = data.filter((val) => val["count"] > 0);

      let final = {
        label: label,
        data: data,
      };
      return final;
    }
    if (type === 1) {
      dataXto0p8 = timeline
        .filter((val) => val["dim(X)"] < 0.8)
        .map((val) => {
          return {
            key:
              val["dim(X)"].toFixed(4) +
              val["dim(Y)"].toFixed(4) +
              val["Velocity"].toFixed(4),
            "dim(X)": val["dim(X)"],
            // "dim(Y)": val["dim(Y)"],
            // Velocity: val["Velocity"],
          };
        });
      dataXto1p5 = timeline
        .filter((val) => val["dim(X)"] >= 0.8 && val["dim(X)"] < 1.5)
        .map((val) => {
          return {
            key:
              val["dim(X)"].toFixed(4) +
              val["dim(Y)"].toFixed(4) +
              val["Velocity"].toFixed(4),
            "dim(X)": val["dim(X)"],
            // "dim(Y)": val["dim(Y)"],
            // Velocity: val["Velocity"],
          };
        });
      dataXto2 = timeline
        .filter((val) => val["dim(X)"] >= 1.5 && val["dim(X)"] < 2)
        .map((val) => {
          return {
            key:
              val["dim(X)"].toFixed(4) +
              val["dim(Y)"].toFixed(4) +
              val["Velocity"].toFixed(4),
            "dim(X)": val["dim(X)"],
            // "dim(Y)": val["dim(Y)"],
            // Velocity: val["Velocity"],
          };
        });

      dataXto4 = timeline
        .filter((val) => val["dim(X)"] >= 2 && val["dim(X)"] < 4)
        .map((val) => {
          return {
            key:
              val["dim(X)"].toFixed(4) +
              val["dim(Y)"].toFixed(4) +
              val["Velocity"].toFixed(4),
            "dim(X)": val["dim(X)"],
            // "dim(Y)": val["dim(Y)"],
            // Velocity: val["Velocity"],
          };
        });
      dataXAbove4 = timeline
        .filter((val) => val["dim(X)"] >= 4)
        .map((val) => {
          return {
            key:
              val["dim(X)"].toFixed(4) +
              val["dim(Y)"].toFixed(4) +
              val["Velocity"].toFixed(4),
            "dim(X)": val["dim(X)"],
            "dim(Y)": val["dim(Y)"],
            Velocity: val["Velocity"],
          };
        });

      dataVel0to10 = timeline
        .filter((val) => val["Velocity"] < 10)
        .map((val) => {
          return {
            key:
              val["dim(X)"].toFixed(4) +
              val["dim(Y)"].toFixed(4) +
              val["Velocity"].toFixed(4),
            "dim(X)": val["dim(X)"],
            "dim(Y)": val["dim(Y)"],
            Velocity: val["Velocity"],
          };
        });
      dataVel10to15 = timeline
        .filter((val) => val["dim(Y)"] >= 10 && val["Velocity"] < 15)
        .map((val) => {
          return {
            key:
              val["dim(X)"].toFixed(4) +
              val["dim(Y)"].toFixed(4) +
              val["Velocity"].toFixed(4),
            "dim(X)": val["dim(X)"],
            "dim(Y)": val["dim(Y)"],
            Velocity: val["Velocity"],
          };
        });
      dataVel15to20 = timeline
        .filter((val) => val["dim(Y)"] >= 15 && val["Velocity"] < 20)
        .map((val) => {
          return {
            key:
              val["dim(X)"].toFixed(4) +
              val["dim(Y)"].toFixed(4) +
              val["Velocity"].toFixed(4),
            "dim(X)": val["dim(X)"],
            "dim(Y)": val["dim(Y)"],
            Velocity: val["Velocity"],
          };
        });

      dataVel20to30 = timeline
        .filter((val) => val["dim(Y)"] >= 20 && val["Velocity"] < 30)
        .map((val) => {
          return {
            key:
              val["dim(X)"].toFixed(4) +
              val["dim(Y)"].toFixed(4) +
              val["Velocity"].toFixed(4),
            "dim(X)": val["dim(X)"],
            "dim(Y)": val["dim(Y)"],
            Velocity: val["Velocity"],
          };
        });
      dataVelAbove30 = timeline
        .filter((val) => val["Velocity"] >= 30)
        .map((val) => {
          return {
            key:
              val["dim(X)"].toFixed(4) +
              val["dim(Y)"].toFixed(4) +
              val["Velocity"].toFixed(4),
            "dim(X)": val["dim(X)"],
            "dim(Y)": val["dim(Y)"],
            Velocity: val["Velocity"],
          };
        });

      data.push({
        name: "Dimension X 0-0.8 \n" + label,
        count: dataXto0p8.length,
        data: dataXto0p8,
        fill: "#ed15bb",
      });
      data.push({
        name: "Dimension X 0.8-1.5 \n" + label,
        count: dataXto1p5.length,
        data: dataXto1p5,
        fill: "#1559ed",
      });
      data.push({
        name: "Dimension X 1.5-2 \n" + label,
        count: dataXto2.length,
        data: dataXto2,
        fill: "#158fed",
      });
      data.push({
        name: "Dimension X 2-4 \n" + label,
        count: dataXto4.length,
        data: dataXto4,
        fill: "#7aed15",
      });
      data.push({
        name: "Dimension X 4 and Above \n" + label,
        count: dataXAbove4.length,
        data: dataXAbove4,
        fill: "#15c2ed",
      });

      data.push({
        name: "Velocity 0-10 \n" + label,
        count: dataVel0to10.length,
        data: dataVel0to10,
        fill: "#16a600",
      });
      data.push({
        name: "Velocity 10-15 \n" + label,
        count: dataVel10to15.length,
        data: dataVel10to15,
        fill: "#ffa200",
      });
      data.push({
        name: "Velocity 10-20 \n" + label,
        count: dataVel15to20.length,
        data: dataVel15to20,
        fill: "#a60300",
      });
      data.push({
        name: "Velocity 20-30 \n" + label,
        count: dataVel20to30.length,
        data: dataVel20to30,
        fill: "#a18600",
      });
      data.push({
        name: "Velocity 30 and Above \n" + label,
        count: dataVelAbove30.length,
        data: dataVelAbove30,
        fill: "#15c2ed",
      });
      data = data.filter((val) => val["count"] > 0);

      let final = {
        label: label,
        data: data,
      };
      return final;
    }
    if (type === 2) {
      dataXto0p8 = timeline
        .filter((val) => val["dim(X)"] < 0.8)
        .map((val) => {
          return {
            key:
              val["dim(X)"].toFixed(4) +
              val["dim(Y)"].toFixed(4) +
              val["Velocity"].toFixed(4),
            "dim(X)": val["dim(X)"],
            "dim(Y)": val["dim(Y)"],
            Velocity: val["Velocity"],
          };
        });
      dataXto1p5 = timeline
        .filter((val) => val["dim(X)"] >= 0.8 && val["dim(X)"] < 1.5)
        .map((val) => {
          return {
            key:
              val["dim(X)"].toFixed(4) +
              val["dim(Y)"].toFixed(4) +
              val["Velocity"].toFixed(4),
            "dim(X)": val["dim(X)"],
            "dim(Y)": val["dim(Y)"],
            Velocity: val["Velocity"],
          };
        });
      dataXto2 = timeline
        .filter((val) => val["dim(X)"] >= 1.5 && val["dim(X)"] < 2)
        .map((val) => {
          return {
            key:
              val["dim(X)"].toFixed(4) +
              val["dim(Y)"].toFixed(4) +
              val["Velocity"].toFixed(4),
            "dim(X)": val["dim(X)"],
            "dim(Y)": val["dim(Y)"],
            Velocity: val["Velocity"],
          };
        });

      dataXto4 = timeline
        .filter((val) => val["dim(X)"] >= 2 && val["dim(X)"] < 4)
        .map((val) => {
          return {
            key:
              val["dim(X)"].toFixed(4) +
              val["dim(Y)"].toFixed(4) +
              val["Velocity"].toFixed(4),
            "dim(X)": val["dim(X)"],
            "dim(Y)": val["dim(Y)"],
            Velocity: val["Velocity"],
          };
        });
      dataXAbove4 = timeline
        .filter((val) => val["dim(X)"] >= 4)
        .map((val) => {
          return {
            key:
              val["dim(X)"].toFixed(4) +
              val["dim(Y)"].toFixed(4) +
              val["Velocity"].toFixed(4),
            "dim(X)": val["dim(X)"],
            "dim(Y)": val["dim(Y)"],
            Velocity: val["Velocity"],
          };
        });

      dataVel0to10 = timeline
        .filter((val) => val["Velocity"] < 10)
        .map((val) => {
          return {
            key:
              val["dim(X)"].toFixed(4) +
              val["dim(Y)"].toFixed(4) +
              val["Velocity"].toFixed(4),
            "dim(X)": val["dim(X)"],
            "dim(Y)": val["dim(Y)"],
            Velocity: val["Velocity"],
          };
        });

      dataYto0p8 = timeline
        .filter((val) => val["dim(Y)"] < 0.8)
        .map((val) => {
          return {
            key:
              val["dim(X)"].toFixed(4) +
              val["dim(Y)"].toFixed(4) +
              val["Velocity"].toFixed(4),
            "dim(X)": val["dim(X)"],
            "dim(Y)": val["dim(Y)"],
            Velocity: val["Velocity"],
          };
        });
      dataYto1p5 = timeline
        .filter((val) => val["dim(Y)"] >= 0.8 && val["dim(Y)"] < 1.5)
        .map((val) => {
          return {
            key:
              val["dim(X)"].toFixed(4) +
              val["dim(Y)"].toFixed(4) +
              val["Velocity"].toFixed(4),
            "dim(X)": val["dim(X)"],
            "dim(Y)": val["dim(Y)"],
            Velocity: val["Velocity"],
          };
        });
      dataYto2 = timeline
        .filter((val) => val["dim(Y)"] >= 1.5 && val["dim(Y)"] < 2)
        .map((val) => {
          return {
            key:
              val["dim(X)"].toFixed(4) +
              val["dim(Y)"].toFixed(4) +
              val["Velocity"].toFixed(4),
            "dim(X)": val["dim(X)"],
            "dim(Y)": val["dim(Y)"],
            Velocity: val["Velocity"],
          };
        });

      dataYto4 = timeline
        .filter((val) => val["dim(Y)"] >= 2 && val["dim(Y)"] < 4)
        .map((val) => {
          return {
            key:
              val["dim(X)"].toFixed(4) +
              val["dim(Y)"].toFixed(4) +
              val["Velocity"].toFixed(4),
            "dim(X)": val["dim(X)"],
            "dim(Y)": val["dim(Y)"],
            Velocity: val["Velocity"],
          };
        });
      dataYAbove4 = timeline.filter((val) => val["dim(Y)"] >= 4);

      data.push({
        name: "Dimension X 0-0.8 \n" + label,
        count: dataXto0p8.length,
        data: dataXto0p8,
        fill: "#65a628",
      });
      data.push({
        name: "Dimension X 0.8-1.5\n" + label,
        count: dataXto1p5.length,
        data: dataXto1p5,
        fill: "#a67328",
      });
      data.push({
        name: "Dimension X 1.5-2\n" + label,
        count: dataXto2.length,
        data: dataXto2,
        fill: "#2899a6",
      });
      data.push({
        name: "Dimension X 2-4\n" + label,
        count: dataXto4.length,
        data: dataXto4,
        fill: "#ab0275",
      });
      data.push({
        name: "Dimension X 4 and Above\n" + label,
        count: dataXAbove4.length,
        data: dataXAbove4,
        fill: "#7202ab",
      });
      data.push({
        name: "Dimension Y 0-0.8\n" + label,
        count: dataYto0p8.length,
        data: dataYto0p8,
        fill: "#0237ab",
      });
      data.push({
        name: "Dimension Y 0.8-1.5\n" + label,
        count: dataYto1p5.length,
        data: dataYto1p5,
        fill: "#9315ed",
      });
      data.push({
        name: "Dimension Y 1.5-2\n" + label,
        count: dataYto2.length,
        data: dataYto2,
        fill: "#a63f28",
      });
      data.push({
        name: "Dimension Y 2-4\n" + label,
        count: dataYto4.length,
        data: dataYto4,
        fill: "#c97910",
      });
      data.push({
        name: "Dimension Y 4 and Above\n" + label,
        count: dataYAbove4.length,
        data: dataYAbove4,
        fill: "#c91010",
      });
      data = data.filter((val) => val["count"] > 0);

      let final = {
        label: label,
        data: data,
      };
      return final;
    }

    dataAreato0p8 = timeline
      .filter((val) => val["Area"] < 0.8)
      .map((val) => {
        return {
          key:
            val["dim(X)"].toFixed(4) +
            val["dim(Y)"].toFixed(4) +
            val["Velocity"].toFixed(4),
          "dim(X)": val["dim(X)"],
          "dim(Y)": val["dim(Y)"],
          Velocity: val["Velocity"],
          Area: val["Area"],
        };
      });
    dataAreato1p5 = timeline
      .filter((val) => val["Area"] >= 0.8 && val["Area"] < 1.5)
      .map((val) => {
        return {
          key:
            val["dim(X)"].toFixed(4) +
            val["dim(Y)"].toFixed(4) +
            val["Velocity"].toFixed(4),
          "dim(X)": val["dim(X)"],
          "dim(Y)": val["dim(Y)"],
          Velocity: val["Velocity"],
          Area: val["Area"],
        };
      });
    dataAreato2 = timeline
      .filter((val) => val["Area"] >= 1.5 && val["Area"] < 2)
      .map((val) => {
        return {
          key:
            val["dim(X)"].toFixed(4) +
            val["dim(Y)"].toFixed(4) +
            val["Velocity"].toFixed(4),
          "dim(X)": val["dim(X)"],
          "dim(Y)": val["dim(Y)"],
          Velocity: val["Velocity"],
          Area: val["Area"],
        };
      });

    dataAreato4 = timeline
      .filter((val) => val["Area"] >= 2 && val["Area"] < 4)
      .map((val) => {
        return {
          key:
            val["dim(X)"].toFixed(4) +
            val["dim(Y)"].toFixed(4) +
            val["Velocity"].toFixed(4),
          "dim(X)": val["dim(X)"],
          "dim(Y)": val["dim(Y)"],
          Velocity: val["Velocity"],
          Area: val["Area"],
        };
      });
    dataAreaAbove4 = timeline
      .filter((val) => val["Area"] >= 4)
      .map((val) => {
        return {
          key:
            val["dim(X)"].toFixed(4) +
            val["dim(Y)"].toFixed(4) +
            val["Velocity"].toFixed(4),
          "dim(X)": val["dim(X)"],
          "dim(Y)": val["dim(Y)"],
          Velocity: val["Velocity"],
          Area: val["Area"],
        };
      });

    dataVel0to10 = timeline
      .filter((val) => val["Velocity"] < 10)
      .map((val) => {
        return {
          key:
            val["dim(X)"].toFixed(4) +
            val["dim(Y)"].toFixed(4) +
            val["Velocity"].toFixed(4),
          "dim(X)": val["dim(X)"],
          "dim(Y)": val["dim(Y)"],
          Velocity: val["Velocity"],
          Area: val["Area"],
        };
      });
    dataVel10to15 = timeline
      .filter((val) => val["dim(Y)"] >= 10 && val["Velocity"] < 15)
      .map((val) => {
        return {
          key:
            val["dim(X)"].toFixed(4) +
            val["dim(Y)"].toFixed(4) +
            val["Velocity"].toFixed(4),
          "dim(X)": val["dim(X)"],
          "dim(Y)": val["dim(Y)"],
          Velocity: val["Velocity"],
          Area: val["Area"],
        };
      });
    dataVel15to20 = timeline
      .filter((val) => val["dim(Y)"] >= 15 && val["Velocity"] < 20)
      .map((val) => {
        return {
          key:
            val["dim(X)"].toFixed(4) +
            val["dim(Y)"].toFixed(4) +
            val["Velocity"].toFixed(4),
          "dim(X)": val["dim(X)"],
          "dim(Y)": val["dim(Y)"],
          Velocity: val["Velocity"],
          Area: val["Area"],
        };
      });

    dataVel20to30 = timeline
      .filter((val) => val["dim(Y)"] >= 20 && val["Velocity"] < 30)
      .map((val) => {
        return {
          key:
            val["dim(X)"].toFixed(4) +
            val["dim(Y)"].toFixed(4) +
            val["Velocity"].toFixed(4),
          "dim(X)": val["dim(X)"],
          "dim(Y)": val["dim(Y)"],
          Velocity: val["Velocity"],
          Area: val["Area"],
        };
      });
    dataVelAbove30 = timeline
      .filter((val) => val["Velocity"] >= 30)
      .map((val) => {
        return {
          key:
            val["dim(X)"].toFixed(4) +
            val["dim(Y)"].toFixed(4) +
            val["Velocity"].toFixed(4),
          "dim(X)": val["dim(X)"],
          "dim(Y)": val["dim(Y)"],
          Velocity: val["Velocity"],
          Area: val["Area"],
        };
      });

    data.push({
      name: "Area 0-0.8 \n" + label,
      count: dataAreato0p8.length,
      // data: dataAreato0p8,
      fill: "#ed2015",
    });
    data.push({
      name: "Area  0.8-1.5\n " + label,
      count: dataAreato1p5.length,
      // data: dataAreato1p5,
      fill: "#1559ed",
    });
    data.push({
      name: "Area 1.5-2 \n" + label,
      count: dataAreato2.length,
      // data: dataAreato2,
      fill: "#28a649",
    });
    data.push({
      name: "Area 2-4 \n" + label,
      count: dataAreato4.length,
      // data: dataAreato4,
      fill: "#9315ed",
    });
    data.push({
      name: "Area 4 and Above \n" + label,
      count: dataAreaAbove4.length,
      // data: dataAreaAbove4,
      fill: "#178f8c",
    });

    // data.push({
    //   name: "Velocity 0-10 \n" + label,
    //   count: dataVel0to10.length,
    //   data: dataVel0to10,
    //   fill: "#ff7300",
    // });
    // data.push({
    //   name: "Velocity 10-15 \n" + label,
    //   count: dataVel10to15.length,
    //   data: dataVel10to15,
    //   fill: "#ed5d15",
    // });
    // data.push({
    //   name: "Velocity 10-20 \n" + label,
    //   count: dataVel15to20.length,
    //   data: dataVel15to20,
    //   fill: "#15a5ed",
    // });
    // data.push({
    //   name: "Velocity 20-30 \n" + label,
    //   count: dataVel20to30.length,
    //   data: dataVel20to30,
    //   fill: "#7aed15",
    // });
    // data.push({
    //   name: "Velocity 30 and Above \n" + label,
    //   count: dataVelAbove30.length,
    //   data: dataVelAbove30,
    //   fill: "#00a181",
    // });
    data = data.filter((val) => val["count"] > 0);

    let final = {
      label: label,
      data: data,
    };
    return final;
  } else
    return {
      label: label,
      data: [],
    };
}

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  cx,
  cy,
  innerRadius,
  midAngle,
  outerRadius,
  payload,
  percent,
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + outerRadius * cos;
  const sy = cy + outerRadius * sin;
  const mx = cx + (outerRadius + 70) * cos;
  const my = cy + (outerRadius + 70) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? "start" : "end";
  let name = payload.payload.name.split("\n")[0];
  // let label = payload.payload.name.split("\n")[1];
  console.log(name);
  // console.log(label);
  // console.log(percent);
  return (
    <g className="border-2">
      {/* <text
        x={x}
        y={y}
        fill="black"
        textAnchor="middle"
        dominantBaseline="central"
      >
        {`${payload.payload.name}%`}
      </text> */}
      {/* <text
        fontSize={"12px"}
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey - 8}
        textAnchor={textAnchor}
        fill={payload.payload.fill}
      >{` ${name}`}</text> */}
      {/* <text
        fontSize={"12px"}
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey - 6}
        textAnchor={textAnchor}
        fill={payload.payload.fill}
      >{` ${label.slice(6)}`}</text> */}
      <text
        fontSize={"12px"}
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey - 12}
        dy={18}
        textAnchor={textAnchor}
        fill={payload.payload.fill}
      >
        {`Count ${payload.payload.count} `}
      </text>
      <text
        fontSize={"12px"}
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey + 2}
        dy={18}
        textAnchor={textAnchor}
        fill={payload.payload.fill}
      >
        {`percent ${percent.toFixed(4) * 100}% `}
      </text>
      <path
        d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
        stroke={payload.payload.fill}
        fill="none"
      />
      <circle cx={ex} cy={ey} r={2} fill={payload.payload.fill} stroke="none" />
    </g>
  );
};

const ChartDimensionToday = () => {
  const [timelineData, setTimelineData] = useState([]);
  const { config } = useConfig();
  const { auth } = useAuth();
  const [finishSetup, setFinishSetup] = useState(false);
  const [atIndex, setAtIndex] = useState(0);
  const [loading, setLoading] = useState(true);

  function updateTimelineData() {
    if (request_updateTimelineData_safe === false) {
      return;
    } else {
      request_updateTimelineData_safe = false;
    }
    axios
      .get(
        `/v1/statistics/dimension/hour?token=${auth.token}&day=${
          new Date().getUTCDate() - 1
        }&month=${new Date().getUTCMonth() + 1}`, {
          withCredentials: true,
        }
      )
      .then((res) => {
        let timeline = [];
        for (let i = 0; i < res.data.length; i++) {
          for (let j = 0; j < res.data[i].length; j++) {
            if (res.data[i][j]["dimXY"].length > 0) {
              timeline = timeline.concat(res.data[i][j]["dimXY"]);
            }
          }
        }
        timeline = timeline.filter((val) => val["Area"] > 0);
        timeline = funnelTimelineLogic(timeline, "Area", 3);
        // console.log(timeline);
        // TODO: need to check if this if needed
        // if (JSON.stringify(timelineData) !== JSON.stringify(resData)) {
        // scatterChart
        // timeline = fillLine(timeline);
        setFinishSetup(true);

        setTimelineData((prev) => timeline);
        // setLoading(false);
        // if (totalCountVehicles !== totalVehicles) {
        //   setTotalCountVehicles((prev) => totalVehicles);
        // }
        request_updateTimelineData_safe = true;
      })
      .catch((err) => {
        console.log(
          "error with get hour statistic inside today vehicles-> ",
          err
        );
      });
  }

  useEffect(() => {
    updateTimelineData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Get the up-to-date data for the in-out chart every 1 sec
  useInterval(
    () => {
      if (finishSetup) {
        updateTimelineData();
        setLoading(false);
      } else updateTimelineData();
    },
    3000,
    true
  );

  if (loading) {
    return (
      <div className="bg-gray-300 flex-auto w-full h-full rounded-md overflow-hidden transition-all">
        <div className="w-full h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent  animate-slide"></div>
      </div>
    );
  }

  return (
    <div className="grid w-full h-full">
      <div className="flex flex-col w-full h-102 p-2 border-t-2    border-dashed border-gray-400 bg-opacity-50">
        <div className="w-full h-12 text-center text-lg text-blue-600 ">
          {timelineData["label"]}
        </div>
        <div className="grid grid-flow-col col-span-2 h-full w-full">
          <div className="w-full h-full">
            <ResponsiveContainer>
              {/* <ScatterChart
                  margin={{ top: 20, right: 20, left: 20, bottom: 20 }}
                  key={
                    data["data"]["name"] +
                    data["data"]["fill"] +
                    index +
                    data["data"]["name"]
                  }
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis
                    axisLine={false}
                    name={"dim X"}
                    type="number"
                    tick={{ fontSize: "0.5rem" }}
                    unit={"dimX"}
                    height={15}
                    dataKey={"dim(X)"}
                  />
                  <YAxis
                    axisLine={false}
                    tickLine={true}
                    type="number"
                    name="dim Y"
                    unit={"dimY"}
                    //   unit={"cm"}
                    //   unit={`pixels`}
                    // mirror={true}
                    tick={{ fontSize: "0.6rem" }}
                    // allowDataOverflow={false}
                    // tickMargin={5}
                    width={30}
                    // dx={10}
                    // hide={true}
                    interval="preserveStartEnd"
                    dataKey={"dim(Y)"}
                  />
                  <Tooltip
                    coordinate={{ x: 0, y: 0 }}
                    offset={0}
                    allowEscapeViewBox={{ x: false, y: true }}
                    cursor={{ strokeDasharray: "3 3" }}
                  />
                  <Legend />
                  {data["data"].map((scatter, index) => (
                    <Scatter
                      id={index}
                      name={"Dim(X,Y)"}
                      fontSize={`10px`}
                      key={data["data"]["name"] + data["data"]["fill"] + index}
                      data={scatter["data"]}
                      fill={data["data"]["fill"]}
                    ></Scatter>
                  ))}
                </ScatterChart> */}

              {/* {arg["data"].map((chart, pos) => ( */}
              <PieChart margin={{ top: 15, right: 20, left: 20, bottom: 0 }}>
                <Pie
                  data={timelineData["data"]}
                  dataKey={"count"}
                  cx="50%"
                  cy="50%"
                  // activeShape={renderActiveShape}
                  // activeIndex={atIndex}
                  outerRadius={100}
                  innerRadius={40}
                  fill={timelineData["data"]["fill"]}
                  labelLine={false}
                  // label={data["name"]}
                  label={renderCustomizedLabel}
                  paddingAngle={15}
                  // label
                  nameKey="count"
                  // isAnimationActive
                >
                  {timelineData["data"].map((entry, index) => {
                    {
                      console.log(entry);
                    }
                    // <Cell key={`cell-${index}`} fill={entry["fill"]} />
                  })}
                </Pie>
                {/* <Legend fontSize={"5px"} /> */}
                {/* <Tooltip content={renderCustomizedLabel} /> */}
              </PieChart>
              {/* ))} */}
            </ResponsiveContainer>
          </div>
          {/* ))} */}
        </div>
      </div>
    </div>
  );

  //OTHER LOGIC TGO SAVE FOR THE FUTURE
  // return (
  //   <div className="p-4">
  //     <div className=" font-semibold text-lg text-gray-600 px-2.5 pt-2">
  //       West To East Count
  //     </div>
  //     <div className="w-full 2xl:h-56 xl:h-60 bg-gray-100 bg-opacity-50">
  //       <ResponsiveContainer>
  //         <AreaChart
  //           data={toEast !== undefined ? toEast : toWest}
  //           margin={{ top: 10, right: 0, left: 0, bottom: 0 }}
  //         >
  //           <defs>
  //             {/* <linearGradient id="leaving" x1="0" y1="0" x2="0" y2="1">
  //             <stop offset="100%" stopColor="rgb(156, 163, 175)" />
  //           </linearGradient> */}
  //             <linearGradient
  //               id={toEast !== undefined ? "northToEast" : "eastToNorth"}
  //               x1="0"
  //               y1="0"
  //               x2="0"
  //               y2="1"
  //             >
  //               <stop
  //                 offset="100%"
  //                 stopColor="rgb(59, 130, 246)"
  //                 opacity={0.6}
  //               />
  //             </linearGradient>
  //             <linearGradient
  //               id={toEast !== undefined ? "westToEast" : "eastToWest"}
  //               x1="0"
  //               y1="0"
  //               x2="0"
  //               y2="1"
  //             >
  //               <stop
  //                 offset="100%"
  //                 stopColor="rgb(59, 246, 87)"
  //                 opacity={0.6}
  //               />
  //             </linearGradient>
  //           </defs>
  //           <Tooltip
  //             coordinate={{ x: 0, y: 0 }}
  //             offset={0}
  //             allowEscapeViewBox={{ x: false, y: true }}
  //             content={<CustomTooltip />}
  //           />
  //           <XAxis
  //             axisLine={false}
  //             tick={{ fontSize: "0.5rem" }}
  //             interval="preserveStartEnd"
  //             // interval={0}
  //             // angle={-10}
  //             // dx={20}
  //             // dy={10}
  //             height={15}
  //             dataKey="hour"
  //           />
  //           <YAxis
  //             axisLine={false}
  //             tickLine={true}
  //             // mirror={true}
  //             tick={{ fontSize: "0.6rem" }}
  //             // allowDataOverflow={false}
  //             // tickMargin={5}
  //             width={30}
  //             // dx={10}
  //             // hide={true}
  //             interval="preserveStartEnd"
  //             dataKey="total"
  //           />

  //           <Area
  //             type="natural"
  //             dataKey={toEast !== undefined ? "northToEast" : "eastToNorth"}
  //             stroke="rgb(59, 130, 246)"
  //             strokeWidth={2.5}
  //             fillOpacity={0.2}
  //             fill={
  //               toEast !== undefined ? "url(#northToEast)" : "url(#eastToNorth)"
  //             }
  //           />
  //           <Area
  //             type="natural"
  //             dataKey={toEast !== undefined ? "westToEast" : "eastToWest"}
  //             stroke="rgb(59, 246, 87)"
  //             strokeWidth={2.5}
  //             fillOpacity={0.2}
  //             fill={
  //               toEast !== undefined ? "url(#westToEast)" : "url(#eastToWest)"
  //             }
  //           />
  //         </AreaChart>
  //       </ResponsiveContainer>
  //     </div>
  //   </div>
  // );

  // <div className="p-4">
  //   <div className=" font-semibold text-lg text-gray-600 px-2.5 pt-2">
  //     West To East Count
  //   </div>
  //   <div className="w-full 2xl:h-56 xl:h-60 bg-gray-100 bg-opacity-50">
  //     <ResponsiveContainer>
  //       <AreaChart
  //         data={toEast !== undefined ? toEast : toWest}
  //         margin={{ top: 10, right: 0, left: 0, bottom: 0 }}
  //       >
  //         <defs>
  //           {/* <linearGradient id="leaving" x1="0" y1="0" x2="0" y2="1">
  //             <stop offset="100%" stopColor="rgb(156, 163, 175)" />
  //           </linearGradient> */}
  //           <linearGradient
  //             id={toEast !== undefined ? "northToEast" : "eastToNorth"}
  //             x1="0"
  //             y1="0"
  //             x2="0"
  //             y2="1"
  //           >
  //             <stop
  //               offset="100%"
  //               stopColor="rgb(59, 130, 246)"
  //               opacity={0.6}
  //             />
  //           </linearGradient>
  //           <linearGradient
  //             id={toEast !== undefined ? "westToEast" : "eastToWest"}
  //             x1="0"
  //             y1="0"
  //             x2="0"
  //             y2="1"
  //           >
  //             <stop
  //               offset="100%"
  //               stopColor="rgb(59, 246, 87)"
  //               opacity={0.6}
  //             />
  //           </linearGradient>
  //         </defs>
  //         <Tooltip
  //           coordinate={{ x: 0, y: 0 }}
  //           offset={0}
  //           allowEscapeViewBox={{ x: false, y: true }}
  //           content={<CustomTooltip />}
  //         />
  //         <XAxis
  //           axisLine={false}
  //           tick={{ fontSize: "0.5rem" }}
  //           interval="preserveStartEnd"
  //           // interval={0}
  //           // angle={-10}
  //           // dx={20}
  //           // dy={10}
  //           height={15}
  //           dataKey="hour"
  //         />
  //         <YAxis
  //           axisLine={false}
  //           tickLine={true}
  //           // mirror={true}
  //           tick={{ fontSize: "0.6rem" }}
  //           // allowDataOverflow={false}
  //           // tickMargin={5}
  //           width={30}
  //           // dx={10}
  //           // hide={true}
  //           interval="preserveStartEnd"
  //           dataKey="total"
  //         />

  //         <Area
  //           type="natural"
  //           dataKey={toEast !== undefined ? "northToEast" : "eastToNorth"}
  //           stroke="rgb(59, 130, 246)"
  //           strokeWidth={2.5}
  //           fillOpacity={0.2}
  //           fill={
  //             toEast !== undefined ? "url(#northToEast)" : "url(#eastToNorth)"
  //           }
  //         />
  //         <Area
  //           type="natural"
  //           dataKey={toEast !== undefined ? "westToEast" : "eastToWest"}
  //           stroke="rgb(59, 246, 87)"
  //           strokeWidth={2.5}
  //           fillOpacity={0.2}
  //           fill={
  //             toEast !== undefined ? "url(#westToEast)" : "url(#eastToWest)"
  //           }
  //         />
  //       </AreaChart>
  //     </ResponsiveContainer>
  //   </div>
  // </div>
  //  :
  // <div className="p-4">
  // <div className=" font-semibold text-lg text-gray-600 px-2.5 pt-2">
  //   West To East Count
  // </div>
  // <div className="w-full 2xl:h-56 xl:h-60 bg-gray-100 bg-opacity-50">
  //   <ResponsiveContainer>
  //     <AreaChart
  //       data={toWest}
  //       margin={{ top: 10, right: 0, left: 0, bottom: 0 }}
  //     >
  //       <defs>
  //         {/* <linearGradient id="leaving" x1="0" y1="0" x2="0" y2="1">
  //           <stop offset="100%" stopColor="rgb(156, 163, 175)" />
  //         </linearGradient> */}
  //         <linearGradient id="northToEast" x1="0" y1="0" x2="0" y2="1">
  //           <stop
  //             offset="100%"
  //             stopColor="rgb(59, 130, 246)"
  //             opacity={0.8}
  //           />
  //         </linearGradient>
  //         <linearGradient id="westToEast" x1="0" y1="0" x2="0" y2="1">
  //           <stop
  //             offset="100%"
  //             stopColor="rgb(59, 246, 87)"
  //             opacity={0.6}
  //           />
  //         </linearGradient>
  //       </defs>
  //       <Tooltip
  //         key={id}
  //         coordinate={{ x: 0, y: 0 }}
  //         offset={0}
  //         allowEscapeViewBox={{ x: false, y: true }}
  //         content={<CustomTooltip />}
  //       />
  //       <XAxis
  //         axisLine={false}
  //         tick={{ fontSize: "0.5rem" }}
  //         interval="preserveStartEnd"
  //         // interval={0}
  //         // angle={-10}
  //         // dx={20}
  //         // dy={10}
  //         height={15}
  //         dataKey="hour"
  //       />
  //       <YAxis
  //         axisLine={false}
  //         tickLine={true}
  //         // mirror={true}
  //         tick={{ fontSize: "0.6rem" }}
  //         // allowDataOverflow={false}
  //         // tickMargin={5}
  //         width={30}
  //         // dx={10}
  //         // hide={true}
  //         interval="preserveStartEnd"
  //         dataKey="total"
  //       />
  //       <Area
  //         type="natural"
  //         dataKey="northToEast"
  //         stroke="rgb(59, 130, 246)"
  //         strokeWidth={2.5}
  //         fillOpacity={0.2}
  //         fill="url(#northToEast)"
  //       />
  //       <Area
  //         type="natural"
  //         dataKey="westToEast"
  //         stroke="rgb(59, 246, 87)"
  //         strokeWidth={2.5}
  //         fillOpacity={0.2}
  //         fill="url(#westToEast)"
  //       />
  //     </AreaChart>
  //   </ResponsiveContainer>
  // </div>

  // return (
  //   <div className="p-4">
  //     <div className="w-full h-32 bg-gray-100 bg-opacity-50">
  //       <ResponsiveContainer>
  //         <AreaChart
  //           data={timelineData}
  //           margin={{ top: 10, right: 0, left: 0, bottom: 0 }}
  //         >
  //           <defs>
  //             {/* <linearGradient id="leaving" x1="0" y1="0" x2="0" y2="1">
  //               <stop offset="100%" stopColor="rgb(156, 163, 175)" />
  //             </linearGradient> */}
  //             <linearGradient id="vehicles" x1="0" y1="0" x2="0" y2="1">
  //               <stop offset="100%" stopColor="rgb(59, 130, 246)" />
  //             </linearGradient>
  //           </defs>
  //           <Tooltip
  //             coordinate={{ x: 0, y: 0 }}
  //             offset={0}
  //             allowEscapeViewBox={{ x: false, y: true }}
  //             content={<CustomTooltip />}
  //           />
  //           <XAxis
  //             axisLine={false}
  //             tick={{ fontSize: "0.5rem" }}
  //             interval="preserveStartEnd"
  //             // interval={0}
  //             // angle={-10}
  //             // dx={20}
  //             // dy={10}
  //             height={15}
  //             dataKey="hour"
  //           />
  //           <YAxis
  //             axisLine={false}
  //             tickLine={true}
  //             // mirror={true}
  //             tick={{ fontSize: "0.6rem" }}
  //             // allowDataOverflow={false}
  //             // tickMargin={5}
  //             width={30}
  //             // dx={10}
  //             // hide={true}
  //             interval="preserveStartEnd"
  //             dataKey="vehicles"
  //           />
  //           {
  //             <Area
  //               type="natural"
  //               dataKey="vehicles"
  //               stroke="rgb(59, 130, 246)"
  //               strokeWidth={2.5}
  //               fillOpacity={0.2}
  //               fill="url(#vehicles)"
  //             />
  //           }
  //         </AreaChart>
  //       </ResponsiveContainer>
  //     </div>
  //   </div>
  // );
  // };
};
// function fillLine(timeline) {
//   let temp = [];

//   // Minus 1 to hide current hour (if now it's 10:40, show in the chart only until 9:59)
//   for (let i = 0; i <= new Date().getHours(); i++) {
//     let hour = i < 10 ? `0${i}:00` : `${i}:00`;
//     let res = findHourData(timeline, hour);

//     if (res !== -1) {
//       temp.push(res);
//     } else {
//       temp.push({
//         hour: hour,
//         data: [
//           {
//             dimX: 0,
//             dimY: 0,
//             dimXY: 0,
//           },
//         ],
//         rgb: "rgb(0,0,0)",
//       });
//     }
//   }
//   return temp;
// }
// const CustomTooltips = ({ payload }) => {
//   console.log(payload);

//   // if (active && payload && payload.length) {
//   //   if (
//   //     payload[0] &&
//   //     payload[1] &&
//   //     payload[0].value === 0 &&
//   //     payload[1].value === 0
//   //   ) {
//   //     return null;
//   //   } else if (payload[0] && payload[0].value === 0) {
//   //     return null;
//   //   } else if (payload[1] && payload[1].value === 0) {
//   //     return null;
//   //   }

//   //   return (
//   //     <div className="bg-white shadow-xl p-4 text-sm border rounded-md space-y-1 animate-fadeIn">
//   //       {payload[0] && (
//   //         <p
//   //           className={clsx({
//   //             "text-blue-500": payload[0].dataKey === "dimX",
//   //           })}
//   //         >{` ${payload[0].value.toLocaleString()}`}</p>
//   //       )}
//   //       {payload[1] && (
//   //         <p
//   //           className={clsx({
//   //             "text-green-500": payload[1].dataKey === "outCount",
//   //           })}
//   //         >{`${payload[1].value.toLocaleString()}`}</p>
//   //       )}

//   //       {/* <p className="text-gray-400">Total: {totalVisits.toLocaleString()}</p> */}
//   //     </div>
//   //   );
//   // }

//   return null;
// };

// const renderActiveShape = (props) => {
//   const {
//     cx,
//     cy,
//     midAngle,
//     innerRadius,
//     outerRadius,
//     startAngle,
//     endAngle,
//     fill,
//     payload,
//   } = props;
//   console.log(payload);
//   const RADIAN = Math.PI / 180;
//   const sin = Math.sin(-RADIAN * midAngle);
//   const cos = Math.cos(-RADIAN * midAngle);
//   const sx = cx + (outerRadius + 10) * cos;
//   const sy = cy + (outerRadius + 10) * sin;
//   const mx = cx + (outerRadius + 30) * cos;
//   const my = cy + (outerRadius + 30) * sin;
//   const ex = mx + (cos >= 0 ? 1 : -1) * 22;
//   const ey = my;
//   const textAnchor = cos >= 0 ? "start" : "end";

//   return (
//     <g>
//       <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
//         {payload.name}
//       </text>
//       <Sector
//         cx={cx}
//         cy={cy}
//         innerRadius={innerRadius}
//         outerRadius={outerRadius}
//         startAngle={startAngle}
//         endAngle={endAngle}
//         fill={payload.payload.fill}
//       />
//       <Sector
//         cx={cx}
//         cy={cy}
//         startAngle={startAngle}
//         endAngle={endAngle}
//         innerRadius={outerRadius + 6}
//         outerRadius={outerRadius + 10}
//         fill={payload.payload.fill}
//       />
//     </g>
//   );
// };

export default ChartDimensionToday;
